/* Earthly Habit — predictive search
   Uses Shopify's /search/suggest.json endpoint. Debounced 200ms. */

(function () {
  'use strict';

  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  const input = overlay.querySelector('input[type="search"]');
  const results = overlay.querySelector('[data-search-results]');
  const empty = overlay.querySelector('[data-search-empty]');
  if (!input || !results) return;

  let abortCtrl;
  let timer;

  const debounce = (fn, ms = 200) => (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };

  const search = async (q) => {
    if (!q || q.length < 2) {
      results.innerHTML = '';
      empty && (empty.hidden = false);
      return;
    }
    empty && (empty.hidden = true);
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();
    try {
      const url = `${window.Shopify.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,article,collection,page&resources[limit]=6&section_id=predictive-search`;
      const res = await fetch(url, { signal: abortCtrl.signal });
      if (!res.ok) throw new Error('search failed');
      const text = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = text;
      const fresh = tmp.querySelector('[data-predictive-results]');
      results.innerHTML = fresh ? fresh.innerHTML : '<p class="search-no-results">No results.</p>';
    } catch (err) {
      if (err.name !== 'AbortError') console.error('predictive-search', err);
    }
  };

  input.addEventListener('input', debounce((e) => search(e.target.value.trim())));

  // Trending suggestion clicks fill input
  overlay.querySelectorAll('[data-trending]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      input.value = b.dataset.trending || b.textContent.trim();
      input.dispatchEvent(new Event('input'));
      input.focus();
    })
  );
})();
